import React, { useCallback } from "react";
import { DataGrid } from "../../DataGrid/DataGrid";

import { useStore } from "../../../stores/store";
import debounce from "lodash/debounce";

export type TaxParcel = {
  parcelNumber: string;
  township: string;
  topLabel: string;
};

interface ResultsGridProps {
  columns: any[];
  rows: TaxParcel[];
  isSelectable?: boolean;
  includePagination?: boolean;
}

export const ResultsGrid = (props: ResultsGridProps) => {
  const { mapView, setSelectedResults, highlightLayerView, setHighlightHandle, selectedResults } = useStore();

  const onRowClick = useCallback((row) => {
    if (!row || !mapView) return;
    const geometry = row.original.geometry;
    if (geometry && geometry.extent) {
      mapView?.goTo(geometry.extent.expand(1.25));
    }
  }, []);

  const onRowSelectionChange = useCallback((selection) => {
    const _selectedResults = props.rows.filter((r, i) => {
      return selection[i];
    });
    setSelectedResults(_selectedResults);
    addHoverHighlightGraphic();
  }, []);

  const addHoverHighlightGraphic = useCallback(
    debounce(
      (row) => {
        if (!highlightLayerView) return;
        const _highlightLayerView = highlightLayerView as __esri.GraphicsLayerView | __esri.FeatureLayerView;
        if (_highlightLayerView.layer.type === "feature") {

          const _featureLayerView = _highlightLayerView as __esri.FeatureLayerView;
          _featureLayerView.highlightOptions = {
            color: "purple",
            haloColor: "white",
          } as any
          _featureLayerView.queryFeatures({
            where: `FEATUREID IN (${[row ? row.FEATUREID : "-1", ...selectedResults.map((r) => r.FEATUREID)].join(",")})`,
            outFields: ["*"],
          }).then((res) => {
            if (res.features.length > 0) {
              setHighlightHandle(_featureLayerView.highlight(res.features));
            }
          });

        } else if (_highlightLayerView.layer.type === "graphics") {
          const _gfxLayerView = _highlightLayerView as __esri.GraphicsLayerView;
          _gfxLayerView.queryGraphics().then((res) => {
            const graphic = res.find((f) => { return f.attributes.OBJECTID === row?.OBJECTID; });
            if (graphic) {
              setHighlightHandle(_gfxLayerView.highlight(graphic));
            }
          });
        }
      },
      [10]
    ),
    [highlightLayerView, selectedResults]
  );

  const onRowHover = useCallback(
    (row?) => {
      // if (!row) {
      //   setHighlightHandle(null);
      //   return;
      // }
      addHoverHighlightGraphic(row?.original);
    },
    [addHoverHighlightGraphic]
  );

  return (
    <div>
      <DataGrid
        className="max-h-52"
        columns={props.columns}
        rows={props.rows}
        onRowClick={onRowClick}
        onRowSelectionChange={onRowSelectionChange}
        onRowHover={onRowHover}
        includeSelection={props.isSelectable}
        includePagination={props.includePagination}
      />
    </div>
  );
};
